import {
  getBirthdayInFormat,
  getDate,
  getMonths,
  getYears,
  validateAge,
  simplyClick,
} from "../../helpers";
import { errorEventsBirthday } from "../../constants";
import { ButtonSubmit } from "../ButtonSubmit";
import "./Birthday.scss";
import cn from "classnames";
import { useState } from "react";

export const Birthday = ({ data, setData, nextStep }) => {
  const [errorBirthday, setErrorBirthday] = useState(null);
  const [fieldErrors, setFieldErrors] = useState({});

  const formattedBirthday = getBirthdayInFormat(
    data.year,
    data.month,
    data.day
  );

  const handlerSubmit = (e) => {
    e.preventDefault();

    const {
      status,
      error,
      errors = {},
    } = validateAge(data.month, data.day, data.year);

    setFieldErrors(errors);

    if (!status) {
      let selected = "";
      if (data.month) selected += "M";
      if (data.day) selected += "D";
      if (data.year) selected += "Y";

      const eventKey = errorEventsBirthday[selected] || "err_lnd_age_nodate";
      simplyClick(eventKey);

      setErrorBirthday(error);
      return;
    }

    setData({
      ...data,
      birthday: formattedBirthday,
    });

    simplyClick("cl_lnd_st2_continue", { text: formattedBirthday });
    nextStep();
  };

  const handleAddMonth = ({ target: { value } }) => {
    setErrorBirthday(null);

    setData({
      ...data,
      month: value,
    });

    simplyClick("cl_lnd_st2_month_choose", { text: value });
  };

  const handleAddDay = ({ target: { value } }) => {
    setErrorBirthday(null);

    setData({
      ...data,
      day: value,
    });

    simplyClick("cl_lnd_st2_day_choose", { text: value });
  };

  const handleAddYear = ({ target: { value } }) => {
    setErrorBirthday(null);

    setData({
      ...data,
      year: value,
    });

    simplyClick("cl_lnd_st2_year_choose", { text: value });
  };

  return (
    <form className="birthday" onSubmit={handlerSubmit}>
      <h1 className="global__title global__title-mobile">
        When’s your birthday?
      </h1>

      <div className="date__wrapper">
        <div className="date__wrapper-select">
          <select
            value={data.month || "default"}
            onChange={handleAddMonth}
            className={cn({
              active: data.month !== "",
              error: fieldErrors.month,
            })}
          >
            <option value="default" disabled hidden>
              Month
            </option>
            {getMonths().map((item, index) => (
              <option key={index} value={index}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="date__wrapper-select">
          <select
            value={data.day || "default"}
            onChange={handleAddDay}
            className={cn({
              active: data.day !== "",
              error: fieldErrors.day,
            })}
          >
            <option value="default" disabled hidden>
              Day
            </option>
            {getDate().map((item, index) => (
              <option key={index} value={index}>
                {item}
              </option>
            ))}
          </select>
        </div>

        <div className="date__wrapper-select">
          <select
            value={data.year || "default"}
            onChange={handleAddYear}
            className={cn({
              active: data.year !== "",
              error: fieldErrors.year,
            })}
          >
            <option value="default" disabled hidden>
              Year
            </option>
            {getYears().map((item, index) => (
              <option key={index} value={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
      </div>

      {errorBirthday && <p className="error-text">{errorBirthday}</p>}
      <ButtonSubmit text="Continue" />

      <div className="slider__box">
        <span className="step active"></span>
        <span className="step active"></span>
        <span className="step"></span>
        <span className="step"></span>
        <span className="step"></span>
      </div>
    </form>
  );
};
